import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectAppraisalSurchargesState = createSelector(
  getSystem,
  ({ appraisalSurcharges }) => appraisalSurcharges,
);

export const selectAppraisalSurchargesList = createSelector(
  selectAppraisalSurchargesState,
  ({ appraisalSurcharges }) => appraisalSurcharges,
);

export const selectAppraisalSurchargesValues = createSelector(
  selectAppraisalSurchargesList,
  Object.values,
);

export const selectFilteredAppraisalSurcharges = createSelector(
  getDebouncedSearchValue,
  selectAppraisalSurchargesValues,
  searchItems(({ name, description }) => [name, description]),
);
